"use strict";
exports.__esModule = true;
var constants_1 = require("../constants");
var LoginWindow = /** @class */ (function () {
    function LoginWindow(url, authHost, onSuccess, onError) {
        var _this = this;
        this.handleAuthMessage = function (event) {
            var data = event.data;
            if (event.origin !== _this.authHost) {
                return;
            }
            if (data.jwt && data.user_info) {
                _this.onSuccess({ jwt: data.jwt, userInfo: data.user_info });
            }
            else {
                _this.onError('Unexpected login data');
            }
            _this.authWindow.close();
            _this.cleanup();
        };
        this.authWindow = window.open(url, 'myOuath', constants_1.POPUP_OPTIONS);
        this.authHost = authHost;
        if (!this.authWindow) {
            this.onError("Can't create auth window");
            return;
        }
        this.onSuccess = onSuccess;
        this.onError = onError;
        this.windowObserver();
    }
    LoginWindow.prototype.windowObserver = function () {
        var _this = this;
        window.addEventListener('message', this.handleAuthMessage);
        this.interval = setInterval(function () {
            if (_this.authWindow.closed) {
                _this.onError('Auth window closed by user');
                _this.cleanup();
            }
        }, constants_1.CHECK_AUTH_WINDOW_INTERVAL);
    };
    LoginWindow.prototype.cleanup = function () {
        window.removeEventListener('message', this.handleAuthMessage);
        clearInterval(this.interval);
    };
    return LoginWindow;
}());
exports["default"] = LoginWindow;
